import React from 'react';

const TarifaSection = () => {
  return (
    <section id="tarifas" className="relative pt-16 sm:pt-20 md:pt-28 pb-16 sm:pb-20 md:pb-24 px-4 sm:px-8 md:px-12 lg:px-20 bg-transparent overflow-hidden">

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header con estilo audaz e impactante */}
        <div className="mb-10 sm:mb-14 text-center">
          <p className="text-[11px] sm:text-xs font-mono uppercase tracking-[0.25em] text-blue-400 mb-2">
            PLANES & HORARIOS
          </p>
          <h2 className="anton-font text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white uppercase leading-tight tracking-tight">
            HORARIOS Y SERVICIOS DE <span className="text-blue-500">NUESTRO GYM</span>
          </h2>
        </div>

        {/* Grid de tarjetas estilo Justin adaptado a la estética Energy Gym */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 items-stretch">

          {/* Tarjeta 1: Horarios */}
          <div className="group bg-[#111319] hover:bg-[#141822] rounded-[1.75rem] p-6 sm:p-8 border border-white/10 hover:border-blue-500/30 transition-all duration-300 shadow-[0_15px_35px_rgba(0,0,0,0.6)] flex flex-col justify-between min-h-[380px]">
            <div>
              {/* Etiqueta superior estilo DETAILS */}
              <div className="flex items-center justify-between mb-4">
                <span className="text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.2em] text-neutral-400">
                  DETALLES
                </span>
                <span className="text-[10px] sm:text-[11px] font-mono uppercase tracking-wider text-blue-400/80 bg-blue-500/10 px-2 py-0.5 rounded">
                  TURNO COMPLETO
                </span>
              </div>

              {/* Título principal de la tarjeta */}
              <h3 className="anton-font text-3xl sm:text-4xl text-white uppercase tracking-tight mb-2">
                HORARIOS
              </h3>

              {/* Sub-etiqueta secundaria tipo email/contacto */}
              <p className="text-[11px] sm:text-xs font-mono uppercase tracking-wider text-blue-400/90 mb-6">
                DISPONIBILIDAD SEMANAL
              </p>

              {/* Contenido central */}
              <div className="space-y-3.5 text-sm sm:text-base text-neutral-200">
                <div className="border-l-2 border-blue-500 pl-3">
                  <span className="text-xs font-mono uppercase tracking-wider text-neutral-400 block mb-0.5">
                    Lunes a Viernes
                  </span>
                  <p className="font-semibold text-white">8:00 am - 1:30 pm</p>
                  <p className="font-semibold text-white">4:00 pm - 10:00 pm</p>
                </div>

                <div className="border-l-2 border-neutral-700 pl-3 pt-1">
                  <span className="text-xs font-mono uppercase tracking-wider text-neutral-400 block mb-0.5">
                    Sábados
                  </span>
                  <p className="font-semibold text-white">9:00 am - 2:00 pm</p>
                  <p className="font-semibold text-white">4:00 pm - 8:30 pm</p>
                </div>
              </div>
            </div>

            {/* Texto inferior descriptivo alineado al pie */}
            <div className="mt-8 pt-4 border-t border-white/5 flex items-center justify-between">
              <p className="text-xs text-neutral-400 leading-relaxed">
                Domingos día de descanso y mantenimiento general.
              </p>
            </div>
          </div>

          {/* Tarjeta 2: Membresías */}
          <div className="group bg-[#111319] hover:bg-[#141822] rounded-[1.75rem] p-6 sm:p-8 border border-white/10 hover:border-blue-500/30 transition-all duration-300 shadow-[0_15px_35px_rgba(0,0,0,0.6)] flex flex-col justify-between min-h-[380px]">
            <div>
              {/* Etiqueta superior estilo DETAILS */}
              <div className="flex items-center justify-between mb-4">
                <span className="text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.2em] text-neutral-400">
                  DETALLES
                </span>
                <span className="text-[10px] sm:text-[11px] font-mono uppercase tracking-wider text-neutral-400 bg-white/5 px-2 py-0.5 rounded">
                  PLANES
                </span>
              </div>

              {/* Título principal de la tarjeta */}
              <h3 className="anton-font text-3xl sm:text-4xl text-white uppercase tracking-tight mb-2">
                MEMBRESÍAS
              </h3>

              {/* Sub-etiqueta secundaria tipo email/contacto */}
              <p className="text-[11px] sm:text-xs font-mono uppercase tracking-wider text-blue-400/90 mb-6">
                PROMOCIONES & TARIFAS
              </p>

              {/* Contenido central */}
              <div className="bg-black/40 rounded-xl p-5 border border-white/5 text-center my-auto flex flex-col justify-center items-center min-h-[140px]">
                <span className="anton-font text-2xl sm:text-3xl text-white tracking-widest uppercase">
                  PRÓXIMAMENTE
                </span>
                <p className="text-xs sm:text-sm text-neutral-400 mt-2">
                  Nuevos planes mensuales, trimestrales y promociones especiales.
                </p>
              </div>
            </div>

            {/* Texto inferior descriptivo alineado al pie */}
            <div className="mt-8 pt-4 border-t border-white/5">
              <p className="text-xs text-neutral-400 leading-relaxed">
                Consultas y promociones vigentes directamente en recepción.
              </p>
            </div>
          </div>

          {/* Tarjeta 3: Servicios */}
          <div className="group bg-[#111319] hover:bg-[#141822] rounded-[1.75rem] p-6 sm:p-8 border border-white/10 hover:border-blue-500/30 transition-all duration-300 shadow-[0_15px_35px_rgba(0,0,0,0.6)] flex flex-col justify-between min-h-[380px] md:col-span-2 lg:col-span-1">
            <div>
              {/* Etiqueta superior estilo DETAILS */}
              <div className="flex items-center justify-between mb-4">
                <span className="text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.2em] text-neutral-400">
                  DETALLES
                </span>
                <span className="text-[10px] sm:text-[11px] font-mono uppercase tracking-wider text-blue-400/80 bg-blue-500/10 px-2 py-0.5 rounded">
                  INCLUIDOS
                </span>
              </div>

              {/* Título principal de la tarjeta */}
              <h3 className="anton-font text-3xl sm:text-4xl text-white uppercase tracking-tight mb-2">
                SERVICIOS
              </h3>

              {/* Sub-etiqueta secundaria tipo email/contacto */}
              <p className="text-[11px] sm:text-xs font-mono uppercase tracking-wider text-blue-400/90 mb-6">
                EQUIPAMIENTO & GUÍA
              </p>

              {/* Contenido central */}
              <div className="space-y-3">
                <div className="bg-black/40 rounded-xl p-3 border border-white/5">
                  <p className="text-sm font-medium text-white">
                    Área de Acondicionamiento Físico
                  </p>
                </div>
                <div className="bg-black/40 rounded-xl p-3 border border-white/5">
                  <p className="text-sm font-medium text-white">
                    Entrenamiento Personalizado
                  </p>
                </div>
                <div className="bg-black/40 rounded-xl p-3 border border-white/5">
                  <p className="text-sm font-medium text-white">
                    Asesoría Nutricional
                  </p>
                </div>
              </div>
            </div>

            {/* Texto inferior descriptivo alineado al pie */}
            <div className="mt-8 pt-4 border-t border-white/5">
              <p className="text-xs text-neutral-400 leading-relaxed">
                Espacio integral equipado para tu constante progreso físico.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TarifaSection;
